'use strict';
import facets from '../modules/facets';
import {Url} from '@/utils/url';
import get from 'lodash/get';
import store from '@/store';

export default function () {
  $(document).ready(function () {
    const isSearch = $('.page-search').length;
    const search_string = $('#searchTabSearchString').val();
    const content_search_url = ACC.config.encodedContextPath + '/search/contentsearch/';
    const b2b_articles_search_url = ACC.config.encodedContextPath + '/search/articlessearch/';
    const b2b_other_content_search_url = ACC.config.encodedContextPath + '/search/othercontentsearch/';
    const archive_search_url = ACC.config.encodedContextPath + '/search/archive/';
    const error_loading_msg = '<div>Sorry, there was a problem loading search results.</div>'; // a base property would be nice!
    let tab_fetched = {products: true, archive: false, content: false, articles: false, 'other-content': false};

    if (isSearch) {
      main();
    }

    function getDefaultViewOptions(url) {
      // Default values if ACC.paginationsort is not available
      let pageSize = 24;
      let currentPage = 0;
      let sort = 'newest';

      if (ACC && ACC.paginationsort) {
        pageSize = ACC.paginationsort.articlesPageSize;
        currentPage = ACC.paginationsort.articlesCurrentPage;
        sort = ACC.paginationsort.articlesSort;

        if (url === b2b_other_content_search_url) {
          pageSize = ACC.paginationsort.otherContentPageSize;
          currentPage = ACC.paginationsort.otherContentCurrentPage;
          sort = ACC.paginationsort.otherContentSort;
        }
      } else if (url === b2b_other_content_search_url) {
        sort = 'name-asc';
      }

      return {
        pageSize,
        currentPage,
        sort,
      };
    }

    function performSearchAjax(url, options) {
      options = Object.assign({skipColumns: []}, getDefaultViewOptions(url), options);
      let params = {
        q: search_string,
        pageSize: options.pageSize,
        page: options.currentPage,
        sort: options.sort,
      };

      let paramsList = [];
      for (let param in params) {
        if (options.skipColumns && options.skipColumns.indexOf(param) > -1) {
          continue;
        }

        paramsList.push(`${param}=${params[param]}`);
      }
      const hasNoParams = url.indexOf('?') === -1;

      return $.ajax({
        url: url,
        type: 'get',
        data: hasNoParams ? `${paramsList.join('&')}` : '',
        dataType: 'json',
      });
    }

    function populateTab(tab, data) {
      try {
        if (tab === '#search-results__archive') {
          $('[data-archive-list]').html($(data));
          facets($(data));
        } else if (tab === '#search-results__articles') {
          $('[data-articles-list]').html($(data));
          facets($(data));
        } else if (tab === '.empty-search-results') {
          $('.empty-search-results').html($(data));
        } else {
          $(tab).html($(data));
          const articleList = $('[data-article-list]');
          facets(articleList);
        }
      } catch (error) {
        console.error(error);
      }
    }

    function revealTabs() {
      $('.not-empty-search-results').removeClass('hidden');
      $('.empty-search-results').addClass('hidden');
    }

    function revealTabsAndOpen(tabname) {
      revealTabs();
      document.querySelector(`#tab-search-results__${tabname}`).click();
      window.loadingIndicator.hide();
    }

    function endLoadAnimationAndShowError(target = '.empty-search-results', content = error_loading_msg) {
      populateTab(target, content);
      window.loadingIndicator.hide();
    }

    function configurePageControls() {
      ACC.paginationsort.bindAll();

      let $elements = $(
        'form[name="sort_form1"], form[name="sort_form2"], form[name="page_form1"], form[name="page_form2"]'
      );
      const activeTabElement = document.getElementsByClassName('pdl-tabs__item is-active')[0];
      if (
        !$elements ||
        !$elements.length ||
        !activeTabElement ||
        activeTabElement.id === 'tab-search-results__archive'
      ) {
        return;
      }

      const currentHash = activeTabElement.id + '-filter';
      $elements.each(function () {
        $(this).attr('action', currentHash);
      });
    }

    function getViewOptionsByTabType(tab) {
      let options = {};
      const urlParams = Url.parse(window.location.href);

      if (tab === '#search-results__archive') {
        options['sort'] = get(urlParams, 'sort', 'relevance');
      }

      return options;
    }
    function populateTabAndMountJs(tab, html, flag) {
      let parentKey = tab.replace('#search-results__', '');
      if (!parentKey || parentKey.length === 0) {
        parentKey = 'default';
      }
      window.dispatchEvent(new CustomEvent(`unmount-vue-dynamic-content-${parentKey}`));
      populateTab(tab, html);
      const ev = new CustomEvent(`init-vue-dynamic-content-${parentKey}`);
      window.dispatchEvent(ev);

      window.loadingIndicator.hide();
      tab_fetched[flag] = true;
      configurePageControls();
    }
    function tabClickHandler(tab, url, flag) {
      if (tab === '#search-results__archive' && store.state.backend.isB2Bsite) {
        return;
      }

      if (ACC && ACC.paginationsort) ACC.paginationsort.currentTab = flag;
      if (tab_fetched[flag] === false) {
        let skipColumns = [];
        if (ACC && ACC.paginationsort && !ACC.paginationsort.passPageSize) {
          skipColumns.push('pageSize');
        }

        window.loadingIndicator.show();
        $.when(performSearchAjax(url, {skipColumns: skipColumns, ...getViewOptionsByTabType(tab)}))
          .done(function (data) {
            populateTabAndMountJs(tab, data.html, flag);
          })
          .fail(function () {
            endLoadAnimationAndShowError();
          });
      }
    }

    $(document).on(
      'click',
      '#search-results__archive .pagination__button, #search-results__archive .pagination__link',
      function (event) {
        event.preventDefault();
        const queryParams = $(event.target).attr('href').split('?')[1];
        // Convert queryParams string to an object
        const paramsObj = {
          currentPage: 0,
          sort: 'relevance',
          pageSize: 24,
        };
        if (queryParams) {
          queryParams.split('&').forEach((param) => {
            const [key, value] = param.split('=');
            if (key === 'page') {
              paramsObj.currentPage = value;
            } else {
              paramsObj[key] = value;
            }
          });
        }
        $.when(performSearchAjax(archive_search_url, paramsObj))
          .done(function (data) {
            populateTabAndMountJs('#search-results__archive', data.html, 'archive');
          })
          .fail(function () {
            // content ajax fail
            endLoadAnimationAndShowError();
          });
      }
    );

    $(document).on(
      'change',
      '#search-results__archive #page_form1, #search-results__archive #page_form2',
      function (event) {
        event.preventDefault();
        const pageSize = event.target.value;
        // Get current query params from the form's action or window.location
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl, window.location.origin);

        // Extract existing query params if present
        let paramsObj = {};
        if (urlObj.search) {
          paramsObj = {
            sort: urlObj.searchParams.get('sort') || 'relevance',
            pageSize: pageSize,
            page: urlObj.searchParams.get('page') || 0,
          };
        } else {
          paramsObj = {pageSize: pageSize};
        }
        $.when(performSearchAjax(archive_search_url, paramsObj))
          .done(function (data) {
            populateTabAndMountJs('#search-results__archive', data.html, 'archive');
          })
          .fail(function () {
            // content ajax fail
            endLoadAnimationAndShowError();
          });
      }
    );

    $(document).on(
      'change',
      '#search-results__archive #sort_form1, #search-results__archive #sort_form2',
      function (event) {
        event.preventDefault();
        const sortParam = event.target.value;
        // Get current query params from the form's action or window.location
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl, window.location.origin);

        // Extract existing query params if present
        let paramsObj = {};
        if (urlObj.search) {
          paramsObj = {
            sort: sortParam,
            pageSize: urlObj.searchParams.get('pageSize') || 24,
            page: urlObj.searchParams.get('page') || 0,
          };
        } else {
          paramsObj = {sort: sortParam};
        }
        $.when(performSearchAjax(archive_search_url, paramsObj))
          .done(function (data) {
            populateTabAndMountJs('#search-results__archive', data.html, 'archive');
          })
          .fail(function () {
            // content ajax fail
            endLoadAnimationAndShowError();
          });
      }
    );

    $(document).on(
      'click',
      '#search-results__content .pagination__button, #search-results__content .pagination__link',
      function (event) {
        event.preventDefault();
        const queryParams = $(event.target).attr('href').split('?')[1];
        const url = `${content_search_url}?${queryParams}`;
        loadResults('content', url);
      }
    );

    if (store.state.backend.isB2Bsite) {
      $('#tab-search-results__products, #tab-search-results__archive').on('click', function (e) {
        const ev = new CustomEvent('plp-set-api-url', {
          detail: {
            url: e.currentTarget.id === 'tab-search-results__archive' ? '/search/archive/' : '/search/productResults/',
          },
        });
        window.dispatchEvent(ev);
        window.isArchivedSearch = e.currentTarget.id === 'tab-search-results__archive';
      });
    } else {
      $('#tab-search-results__products').on('click', function () {
        window.isArchivedSearch = false;
        tabClickHandler('#search-results__products', null, 'products');
      });
      $('#tab-search-results__archive').on('click', function () {
        window.isArchivedSearch = true;
        tabClickHandler('#search-results__archive', archive_search_url, 'archive');
      });
    }

    $('#tab-search-results__content').on('click', function () {
      tabClickHandler('#search-results__content', content_search_url, 'content');
    });

    $('#tab-search-results__articles').on('click', function () {
      tab_fetched.articles = false;
      tabClickHandler('#search-results__articles', b2b_articles_search_url, 'articles');
    });

    $('#tab-search-results__other-content').on('click', function () {
      tab_fetched['other-content'] = false;
      tabClickHandler('#search-results__other-content', b2b_other_content_search_url, 'other-content');
    });

    function decodePlpPaginationHref() {
      $('.pagination__link[href], .pagination__button[href]').each((index, item) => {
        const $item = $(item);
        $item.attr('href', decodeURIComponent($item.attr('href')));
      });
    }

    // On every reload or ajax call finish call decodePlpPaginationHref()
    decodePlpPaginationHref();
    $(window).ajaxComplete(() => {
      decodePlpPaginationHref();
    });

    // Start chained ajax searches if content-related results are 0
    // If the solr search results for products are 0, the backend sets the
    // value of #contentTabSearchResults, a hidden input to 0, and it starts
    // AJAX calls for content and retailers if necessary

    function checkAndLoadContentTab() {
      const nextTab = store.state.backend.isB2Bsite ? 'articles' : 'content';
      const nextTabAjaxUrl = store.state.backend.isB2Bsite ? b2b_articles_search_url : content_search_url;
      if (!$('#' + nextTab + 'TabSearchResults').val()) {
        $('.facetNavRefinements').hide();
        window.loadingIndicator.show();
        loadResults(nextTab, nextTabAjaxUrl);
      } else {
        // products found, reveal tabs and leave product tab open
        revealTabs();
      }
    }

    function main() {
      if (store.state.backend.isB2Bsite) {
        window.addEventListener('plp-data-loaded', (ev) => {
          if (
            ev.detail &&
            ev.detail.options &&
            !ev.detail.options.totalCount &&
            ev.detail.settings.locationId !== 'archive'
          ) {
            checkAndLoadContentTab();
          }
        });
        revealTabs();
      } else {
        checkAndLoadContentTab();
      }
    }

    function loadResults(tab, ajaxUrl) {
      $.when(performSearchAjax(ajaxUrl))
        .done(function (data) {
          populateTab('#search-results__' + tab, data.html);
          tab_fetched[tab] = true;

          if (data.resultcount !== 0 || tab === 'archive') {
            revealTabsAndOpen(tab);
          } else {
            switch (tab) {
              case 'content':
                loadResults('content', content_search_url);
                break;
              case 'articles':
                loadResults('other-content', b2b_other_content_search_url);
                break;
              case 'other-content':
                // present zero results section and hide everything else
                $('.empty-search-results').html(data.searchEmptyhtml);
                window.loadingIndicator.hide();
                break;
            }
          }
        })
        .fail(function () {
          // content ajax fail
          endLoadAnimationAndShowError();
        });
    }
  });
}
